// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__wuqsa","rowOne":"styles_rowOne__Luu8k","rowTwo":"styles_rowTwo__LzvOI"};